import { useEffect, useRef } from 'react'
import TagManager from 'react-gtm-module'
import { useLocation } from 'react-router-dom'
import { getGtmId } from '../config/domainConfig'

function useGTM() {
  const { pathname } = useLocation()
  const isInitialized = useRef(false)

  useEffect(() => {
    if (isInitialized.current) return

    // Container id is resolved from the live hostname (swipeyconnect vs
    // swipeyquiz) — see src/config/domainConfig.js.
    TagManager.initialize({ gtmId: getGtmId() })
    isInitialized.current = true
  }, [pathname])
}

export default useGTM
